(function () {
  'use strict';

  function getZellijApiBase() {
    var cfg = window.ZELLIJ_CONFIG || {};
    var isLocal = window.location.hostname === '127.0.0.1' ||
                  window.location.hostname === 'localhost';
    return isLocal
      ? 'http://localhost:3001/api/zelligehome'
      : (cfg.apiBase || 'https://zellij.vercel.app/api/zelligehome');
  }

  window.ZELLIJ_GET_API_BASE = getZellijApiBase;
})();
